import InputLabel from '@material-ui/core/InputLabel';
export default InputLabel;

// This is a workaround to solve that Material UI types doesn't contain 'ref'.
